import { Box, Tag } from '@coolblue-development/freddy';
import { ReactElement } from 'react';

import { TooltipContainer } from '../../TooltipContainer';
import StockInOtherLocationsIconTag from './StockInOtherLocationsIconTag';

type StockInOtherLocationsIconProps = {
  stockCount?: number;
  url: string;
  index: number;
  totalIndices: number;
};

const StockInOtherLocationsIcon = ({
  stockCount,
  url,
  index,
  totalIndices
}: StockInOtherLocationsIconProps): ReactElement => {
  if (stockCount === null || stockCount === undefined) {
    return (
      <Box>
        <Tag variant='subtle' intent='neutral'>
          - in other locations
        </Tag>
      </Box>
    );
  }

  const message = stockCount === 0 ? 'None in other locations' : `${stockCount} in other locations`;

  return (
    <TooltipContainer
      iconLabel='Open Iris product dashboard'
      data-testid='other-locations-stock-icon'
    >
      <StockInOtherLocationsIconTag
        url={url}
        index={index}
        totalIndices={totalIndices}
        message={message}
      />
    </TooltipContainer>
  );
};

export default StockInOtherLocationsIcon;
